export const sumReducer = (accumulator, currentValue) => accumulator + currentValue
